<div class="box-container">
    <div class="box-img">
        <img [routerLink]="['/']" (click)="close()" class="img" src="assets/images/logo_header-negro.png">
        <img class="absolute" (click)="close()" src="assets/images/icon_cross_mov.png" alt="Close">
    </div>
    <br><br>
    <div class="content-res">
        <p [routerLink]="['/assinatura-digital-para-pessoas']" (click)="close()">FAD® <span>PESSOAL</span><br></p>
        <hr>
    </div>

    <div class="content-res">
        <p class="red" [routerLink]="['/assinatura-digital-para-empresas']" (click)="close()">FAD®
            <span>EMPRESARIAL</span><br></p>
        <hr class="red-hr">
    </div>

    <div class="content-res">
        <p [routerLink]="['/como-comecar-a-assinar-digitalmente']" (click)="close()">PRECISA <span
                style="color: #8e8e8e">DE AJUDA?</span><br></p>
        <hr style="background-color: #8e8e8e; border-color: #8e8e8e">
    </div>

    <div class="content-res">
        <p [routerLink]="['/perguntas-frequentes-da-assinatura-digital-fad']" (click)="close()"><span
                style="color: #8e8e8e">FAQs</span><br></p>
        <hr style="background-color: #8e8e8e; border-color: #8e8e8e">
    </div>
    <hr style="width: 80%; margin: 20px auto 10px; background-color: #8e8e8e; border: none; height: 3px; border-radius: 5px;">
    <div class="content-res">
        <p (click)="close()"><span
                style="color: #8e8e8e"><a target="_blank" style="color: #5c5c5c; text-decoration: none;" href="https://apps.apple.com/us/app/fad-firma-aut-c3-b3grafa-digital/id1295206858">Baixe FAD® <strong>para iOS</strong></a></span><br></p>
        <hr style="background-color: #8e8e8e; border-color: #8e8e8e">
    </div>

    <div class="content-res">
        <p (click)="close()"><span
                style="color: #8e8e8e"><a target="_blank" style="color: #5c5c5c; text-decoration: none;"  href="https://play.google.com/store/apps/details?id=com.na_at.fad">Baixe FAD® <strong>para android </strong></a></span><br></p>
        <hr style="background-color: #8e8e8e; border-color: #8e8e8e">
    </div>

    <div class="content-res">
        <p class="red" (click)="close()">
            <span><a style="color: #5c5c5c; text-decoration: none;" href="https://clientes.firmaautografa.com/seleccion" target="_blank">
                <strong style="color: #A70534;">Visualizador</strong><strong> FAD®</strong></a></span><br></p>
        <hr class="red-hr">
    </div>

    <div class="account">
        <div style="width: 160px; margin: 0 auto;">
            <button style="width: 160px;" mat-button [matMenuTriggerFor]="menu">
                <div class="button-language-container">
                    Brasil (Português) <img width="15px" src="assets/images/m/arrowdown.png" alt="VER MAIS">
                </div>
            </button>
            <mat-menu #menu="matMenu">
                <button mat-menu-item>
                    <a style="color: white" (click)="changeLanguage()">México (Espanhol)</a>
                </button>
            </mat-menu>
        </div>

    </div>

</div>
